<template>
  <div id="app" class="palette-control">
    <v-app>
    <MenuSidebar />
      <main class="padded">
        <router-view></router-view>
      </main>

      <!-- Dev-only Edit Mode Toggle -->
      <v-btn
        v-if="isDev"
        fab
        fixed
        bottom
        right
        class="dev-edit-toggle"
        elevation="4"
        @click="toggleEditMode"
        style="z-index: 9999; margin-bottom: 20px; margin-right: 20px;"
      >
        <v-icon>{{ isDesignModeOn ? 'mdi-pencil-off' : 'mdi-pencil' }}</v-icon>
      </v-btn>
    </v-app>
  </div>
</template>

<script>
import MenuSidebar from '@/components/MenuSidebar.vue'
import { EventBus } from '@/main.js'

export default {
  name: 'app',
  components: {
    MenuSidebar
  },
  data: () => ({
    isDev: process.env.NODE_ENV === 'development',
    isDesignModeOn: false
  }),
  methods: {
    toggleEditMode() {
      this.isDesignModeOn = !this.isDesignModeOn
      document.designMode = this.isDesignModeOn ? 'on' : 'off'
      EventBus.$emit('onEditModeToggle', this.isDesignModeOn)
    }
  }
}
</script>

<style>
#app {
  font-family: 'JetBrains Mono', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: var(--palette-text);
}
.danger-alert {
  color: var(--palette-danger);
}
.padded {
  margin-left: 56px;
  box-sizing: border-box;
  width: calc(100vw - 56px);
  min-height: 100vh;
  overflow-x: hidden;
}

@media (max-width: 720px) {
  .padded {
    margin-left: 56px;
    margin-right: 16px;
    width: auto;
  }
}
#fp-nav ul li a span, 
.fp-slidesNav ul li a span {
  background: radial-gradient(circle, 
    rgba(var(--palette-accent-rgb), 1) 10%, 
    rgba(var(--palette-border-rgb), 1) 100%, 
    rgba(var(--palette-border-rgb), 1) 100%
  );
}
@font-face {
    font-family: bebas;
    src: url('@/assets/fonts/Bebas-Regular.ttf');
}
@font-face {
    font-family: monteserrat;
    src: url('@/assets/fonts/Montserrat-SemiBold.otf');
}
h1 {
  font-size: 30px;
  font-family: 'Sora', bebas, sans-serif;
  color: var(--palette-accent);
}
h2 {
  font-family: 'Sora', monteserrat, sans-serif;
  color: var(--palette-heading-muted);
  font-size: 35px;
}
p {
  font-size: 15px;
  font-family: 'JetBrains Mono', monteserrat, monospace;
  color: var(--palette-text-muted);
}
b {
  margin-left: 0px;
  font-family: 'JetBrains Mono', monteserrat, monospace;
  font-size: 20px;
  color: var(--palette-accent);
}
.dev-edit-toggle {
  background-color: var(--palette-accent) !important;
  color: var(--palette-accent-on) !important;
}
</style>
